// extracted by mini-css-extract-plugin
export default {"errorMessage":"profile_errorMessage__9q-Ky","card":"profile_card__Wx+1Q","photo":"profile_photo__F2JCj","infoWrapper":"profile_infoWrapper__5FhKi","info":"profile_info__wsepF"};